
import React from 'react';

type LoginHeaderProps = {
	data?: any // TODO: Change this
}

/**
 * Top part of login page showing logo and company name
 *
 * @returns 
 */
const LoginHeader: React.FC<LoginHeaderProps> = ({data}) => {	  
	const myPagesUrl = window.location.href
	return(
		<header className="login-header">
			<div className="login-header__logo-container">
				<a href={myPagesUrl} tabIndex={0} aria-label="Qstar mina sidor, startsida">
					<img alt="Qstars logotyp" src="static/images/qstar_logo_yellow.png" />
				</a>
			</div>
		</header>
	)
}

export default LoginHeader